import { render, staticRenderFns } from "./ProposalsDashboard.vue?vue&type=template&id=22cba603&scoped=true&"
import script from "./ProposalsDashboard.vue?vue&type=script&lang=js&"
export * from "./ProposalsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsDashboard.vue?vue&type=style&index=0&id=22cba603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cba603",
  null
  
)

export default component.exports